/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { getVideoElement, isRaiseHandEnabled } from "../CallCommon";
import { getAuthSession } from "../common";
import profileDefault from "../../../assets/images/profile-default.png";
import { globalStrings } from "../../util/translation/languages";

const CallSidebar = (props) => {
  const { raiseHand, activeSpeaker } = props;

  const selectedLanguage = useSelector((state) => state.chat.selectedLanguage);

  const galleryViewParticipants = useSelector(
    (state) => state.lib.galleryViewParticipants,
  );

  const callDetail = useSelector((state) => state.call.callDetail);

  const participants = useMemo(() => {
    return galleryViewParticipants.filter(
      (item) => item.screen_pinned == false,
    );
  }, [galleryViewParticipants]);

  const { user_unique_key } = getAuthSession();
  return (
    <div className="participantsCase ml-3 bg-light-gray p-2 flex-wrap border-radius justify-content-between">
      {participants?.map((item) => {
        const displayName = item.name;
        let handRaiseFlag = isRaiseHandEnabled(item);

        let localhandRaiseFlag =
          callDetail?.participantID?.find(
            (findItem) =>
              findItem.id === item.user_id && item.user_id === user_unique_key,
          )?.hand_raise ?? false;

        let isSender = user_unique_key === callDetail?.senderID;
        let isSameUser = user_unique_key === item.user_id;
        let isNotPrivate = callDetail?.type !== "private";
        let canRemoveRaisedHand = false;

        if (localhandRaiseFlag && isSameUser) {
          canRemoveRaisedHand = true;
        } else if (isSender && isNotPrivate) {
          canRemoveRaisedHand = true;
        }

        let audio_data = false;
        audio_data =
          callDetail?.participantID?.find(
            (findItem) => findItem.id === item.user_id,
          )?.audio ?? false;
        const isMonitorEnabled = callDetail?.monitor_status ?? false;

        let activeSpeakerClass = "";
        if (activeSpeaker === item.jid && item.type === "camera") {
          activeSpeakerClass = "speaker";
        }

        return (
          <div
            className={`thumbnail ${activeSpeakerClass}`}
            key={item?.user_id + item.type}
          >
            {item?.track !== null ? (
              getVideoElement(item.track, "w-100 h-100 object-fit-cover")
            ) : (
              <img
                alt="profile"
                src={profileDefault}
                style={{ verticalAlign: "middle" }}
                id={item.local === true ? "localprofile" : item + "profile"}
                className="thumbnail-img"
              />
            )}
            <div
              className="attendees-name cursor-pointer"
              data-tip
              data-for="displayName"
            >
              <span>{displayName}</span>
            </div>
            <div className="d-flex top-2 right-2 position-absolute gap-1">
              {/* Hand raise icon start */}
              {item.type === "camera" && handRaiseFlag === true ? (
                <a
                  href="javascript:void(0)"
                  className={`small-tags position-relative ${
                    user_unique_key === callDetail?.senderID
                      ? "cursor-default"
                      : ""
                  } ${
                    canRemoveRaisedHand ? "cursor-pointer" : "cursor-intials"
                  }`}
                  data-tip
                  data-for="handraised"
                  onClick={(e) =>
                    canRemoveRaisedHand
                      ? raiseHand(
                          e,
                          { callDetails: callDetail },
                          item.user_id,
                          false,
                        )
                      : ""
                  }
                >
                  <svg fill="none" viewBox="7.65 4.5 42.85 51" width={".8rem"}>
                    <path
                      d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
                      fill="none"
                      stroke="white"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span className="status status-group bg-white text-dark count-badge-small count-badge-sidebar position-absolute right--2 top--0-5">
                    {item.hand_raised_position}
                  </span>
                  <ReactTooltip
                    id="handraised"
                    place="bottom"
                    effect="solid"
                    className="group-tooltip"
                  >
                    {globalStrings[selectedLanguage]?.$raisedHand}
                  </ReactTooltip>
                </a>
              ) : null}
              {/* Hand raise icon end */}

              {/* Presentation View Icon Start*/}
              {item.type === "desktop" && (
                <a
                  href="javascript:void(0)"
                  className={`small-tags position-relative ${
                    user_unique_key === callDetail?.senderID
                      ? "cursor-default"
                      : "cursor-intials"
                  } ${canRemoveRaisedHand ? "cursor-intials" : ""}`}
                  data-tip
                  data-for={`presentationview-${item.user_id}`}
                  onClick={(e) =>
                    canRemoveRaisedHand
                      ? raiseHand(
                          e,
                          { callDetails: callDetail },
                          item.user_id,
                          false,
                        )
                      : ""
                  }
                >
                  <svg width="20px" height="20px" viewBox="2 3 20 17">
                    <path
                      fill="#ffffff"
                      d="M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"
                    ></path>
                  </svg>
                  <ReactTooltip
                    id={`presentationview-${item.user_id}`}
                    place="bottom"
                    effect="solid"
                    className="group-tooltip"
                  >
                    {displayName}
                  </ReactTooltip>
                </a>
              )}
              {/* Presentation View Icon End*/}

              {/* Mute icon start */}
              {item.type === "camera" && !isMonitorEnabled && !audio_data ? (
                <a className="small-tags" id={item.user_id + "audio"}>
                  <svg width="15px" height="15px" viewBox="2.29 2 19.41 20.02">
                    <path
                      fill="#FFFFFF"
                      d="m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
                    ></path>
                    <path
                      fill="#FFFFFF"
                      d="M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
                    ></path>
                  </svg>
                </a>
              ) : null}
              {/* Mute icon end */}
            </div>
          </div>
        );
      })}

      {/* 
            <>
                <div className="thumbnail">
                    <img
                        src="https://app.c2perform.com/files1/user-pics/4/default-user.png"
                        alt="Thumbnail"
                        className="thumbnail-img"
                    />
                    <span className="attendees-name">test</span>

                
                    <div
                        className="small-tags cursor-default"
                        data-tip
                        data-for="handraised"
                    >
                        <svg fill="none" viewBox="7.65 4.5 42.85 51" width={"1rem"}>
                            <path
                                d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
                                fill="none"
                                stroke="white"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></path>
                        </svg>
                        <ReactTooltip
                            id="handraised"
                            place="bottom"
                            effect="solid"
                            className="group-tooltip"
                        >
                            Raised Hand
                        </ReactTooltip>
                    </div>
            
                    <div className="kickOut-tag" data-tip data-for="kickOut">
                        <svg viewBox="2 3 20 18" width={"1rem"}>
                            <path d="m2 12 5 4v-3h9v-2H7V8z" fill="currentColor"></path>
                            <path
                                fill="currentColor"
                                d="M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                            ></path>
                        </svg>
                        <ReactTooltip
                            id="kickOut"
                            place="bottom"
                            effect="solid"
                            className="group-tooltip"
                        >
                            KickOut
                        </ReactTooltip>
                    </div>
              
                </div>
            </> */}
    </div>
  );
};
export default CallSidebar;
